const multipleQuantity = (value: any, multiple: any) => {
  return formatFloat(Math.max(Math.ceil(value / multiple), 1) * multiple);
};

const calculateQuantityAndSalesUnit = ({
  field,
  quantity = 0,
  salesUnitValue = 0,
  unitConversionFactor,
  multiple = 1,
}: any) => {
  let newSalesUnitValue = salesUnitValue;
  let newQuantity = quantity;

  if (field === 'quantity' && !isNaN(quantity) && !isNaN(unitConversionFactor)) {
    const multiplied = multipleQuantity(quantity, multiple);
    newQuantity = multiplied;
    newSalesUnitValue = Math.round((multiplied / unitConversionFactor) * 100) / 100;
  }

  if (field === 'salesUnitValue' && !isNaN(salesUnitValue) && !isNaN(unitConversionFactor)) {
    const quantityFromSalesUnit = Math.ceil(salesUnitValue * unitConversionFactor);
    newQuantity = multipleQuantity(quantityFromSalesUnit, multiple);
    newSalesUnitValue = Math.round((newQuantity / unitConversionFactor) * 100) / 100;
  }

  return { newQuantity, newSalesUnitValue };
};

const formatQuantity = (quantity: number) => {
  return new Intl.NumberFormat('sv', { maximumFractionDigits: 2 }).format(quantity);
};

export { calculateQuantityAndSalesUnit, multipleQuantity, formatQuantity };
